export default "<div>\n    <input matInput [(ngModel)]=\"title\" (keyup)=\"onChange()\" placeholder=\"{{'FILTERS.BY_TITLE.TITLE' | translate}}\">\n</div>"